import {
  EventAttendanceFilter,
  isTemplatePlaceholder,
} from '@/types';

import {
  FlatSearchTree,
  FlatSearchTreeLeafNode,
} from '@components/LoadSearchTemplateDialog/flatSearchTree';

export function checkValidEventAttendance(flatSearchTree: FlatSearchTree) {
  const { nodes } = flatSearchTree;
  const nodeValues = Object.values(nodes);
  const eventAttendanceNodes = nodeValues.filter(
    (x) => x.op === 'filter' && 'name' in x.filter && x.filter.name === 'eventAttendance'
  );
  if (eventAttendanceNodes.length === 0) {
    return true;
  }

  for (const eventAttendanceNode of eventAttendanceNodes) {
    const eventAttendanceNodeValue = (
      (eventAttendanceNode as FlatSearchTreeLeafNode).filter as EventAttendanceFilter
    ).value;

    if (
      (isTemplatePlaceholder(eventAttendanceNodeValue.statusIds) ||
        (!isTemplatePlaceholder(eventAttendanceNodeValue.statusIds) &&
          eventAttendanceNodeValue.statusIds.length === 0)) &&
      (isTemplatePlaceholder(eventAttendanceNodeValue.eventTypeIds) ||
        (!isTemplatePlaceholder(eventAttendanceNodeValue.eventTypeIds) &&
          eventAttendanceNodeValue.eventTypeIds.length === 0)) &&
      (isTemplatePlaceholder(eventAttendanceNodeValue.eventIds) ||
        (!isTemplatePlaceholder(eventAttendanceNodeValue.eventIds) &&
          eventAttendanceNodeValue.eventIds.length === 0)) &&
      (isTemplatePlaceholder(eventAttendanceNodeValue.eventCampaignIds) ||
        (!isTemplatePlaceholder(eventAttendanceNodeValue.eventCampaignIds) &&
          eventAttendanceNodeValue.eventCampaignIds.length === 0)) &&
      (isTemplatePlaceholder(eventAttendanceNodeValue.eventDateRange.startDate) ||
        !eventAttendanceNodeValue.eventDateRange.startDate) &&
      (isTemplatePlaceholder(eventAttendanceNodeValue.eventDateRange.endDate) ||
        !eventAttendanceNodeValue.eventDateRange.endDate)
    ) {
      return false;
    }

    if (
      eventAttendanceNodeValue.eventDateRange.startDate &&
      !isTemplatePlaceholder(eventAttendanceNodeValue.eventDateRange.startDate) &&
      eventAttendanceNodeValue.eventDateRange.endDate &&
      !isTemplatePlaceholder(eventAttendanceNodeValue.eventDateRange.endDate) &&
      new Date(eventAttendanceNodeValue.eventDateRange.startDate).getTime() >
        new Date(eventAttendanceNodeValue.eventDateRange.endDate).getTime()
    ) {
      return false;
    }
  }
  return true;
}

export function getNumEventAttendanceFilters(flatSearchTree: FlatSearchTree) {
  const { nodes } = flatSearchTree;
  const nodeValues = Object.values(nodes);
  const eventAttendanceNodes = nodeValues.filter(
    (x) => x.op === 'filter' && 'name' in x.filter && x.filter.name === 'eventAttendance'
  );
  return eventAttendanceNodes.length;
}
